/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { Legend } from './SeatMapStyled';

export const SeatMapHorizontalLegend = styled(Legend)`
 justify-content: space-between;

 width: ${({ width }) => width && `${width}px`};
 font-size: 13px;
 line-height: 15px;

 .direction {
   display: flex;
   margin: 8px;
   margin-right: -8px;
   justify-content: center;
   align-items: center;

   svg {
    margin-left: 8px;
   }
 }
`;
